export default __webpack_public_path__ + "static/media/mysql.a04abbf7.png";